'use client';

import { useToast } from '@/components/ui/use-toast';
import {
  claimBannerPromo,
  takeStashedBannerClaim,
} from '@/lib/bannerPromo';
import { ErrorHandler } from '@/lib/ErrorHandler';
import { getIsAnonymous } from '@/lib/LocalStorage';
import { WindowDispatchEvent } from '@/lib/WindowDispatchEvent';
import { useEffect, useRef } from 'react';

export default function BannerClaimResume() {
  const { toast } = useToast();
  const claiming = useRef(false);

  useEffect(() => {
    const tryClaim = () => {
      if (claiming.current || getIsAnonymous()) return;
      const pending = takeStashedBannerClaim();
      if (!pending) return;
      claiming.current = true;
      (async () => {
        try {
          const code = await claimBannerPromo(pending.id);
          if (code) {
            toast({ description: `Kampanya kodunuz: ${code}` });
          } else {
            toast({ variant: 'destructive', description: 'Şu an kod verilemiyor' });
          }
        } catch (error) {
          toast({
            variant: 'destructive',
            description: ErrorHandler.getMessage(error).message || 'Kod alınamadı',
          });
        }
      })();
    };

    tryClaim();
    window.addEventListener(WindowDispatchEvent.UPDATE_ANONYMOUS_STATE, tryClaim);
    return () => window.removeEventListener(WindowDispatchEvent.UPDATE_ANONYMOUS_STATE, tryClaim);
  }, [toast]);

  return null;
}
